import { useEffect, useState } from "react";
import SidePanel from "../../components/SidePanel";
import heart_icon from "../../assets/icons/Heart.svg";
import favourited_icon from "../../assets/icons/favorited.svg";
import { IoIosSearch } from "react-icons/io";
import GenerateCardPopup from "../../components/GenerateCardPopup";
import shadow from "../../assets/pic/shadow.svg";
import Spinner from "../../components/Spinner";
import { MdAddToPhotos } from "react-icons/md";
import { useParams } from "react-router-dom";
const CardGeneration = () => {
  const [initialCards, setInitialCards] = useState([]);
  const [cards, setCards] = useState([]);
  const [occasion, setOccasion] = useState([]);
  const [selectedOccasion, setSelectedOccasion] = useState("");
  const [theme, setTheme] = useState("");
  const [forWhom, setForWhom] = useState("");
  const [cardsLoader, setCardsLoader] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [selectedCard, setSelectedCard] = useState("");
  const [selectedCardID, setSelectedCardID] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(20); // Number of cards per page
  const { cardType } = useParams();
  useEffect(() => {
    const fetchMe = async (token) => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/me`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await res.json();
        if (res.status === 200) {
          setFavorites(data.detail.favoriteCards);
        }
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    };
    const token = localStorage.getItem("token");
    if (token) {
      fetchMe(token);
    }
  }, []);
  useEffect(() => {
    if (cardType === "birthday-card") {
      setSelectedOccasion("Birthday");
    } else if (cardType === "christmas") {
      setSelectedOccasion("Christmas");
    } else if (cardType === "new-years") {
      setSelectedOccasion("New Year's");
    }
  }, [cardType]); // Add cardType as a dependency

  useEffect(() => {
    const filteredCards = initialCards.filter((card) => {
      const matchesTheme = theme
        ? card.categories.some((category) =>
            category.name.toLowerCase()?.includes(theme.toLowerCase())
          )
        : true;
      const matchesOccasion = selectedOccasion
        ? card.categories.some((category) => category.name === selectedOccasion)
        : true;
      const matchesForWhom = forWhom
        ? card.tags.some(
            (tag) => tag.name.toLowerCase() === forWhom.toLowerCase()
          )
        : true;
      return matchesOccasion && matchesForWhom && matchesTheme;
    });

    setCards(filteredCards);
  }, [selectedOccasion, forWhom, initialCards, theme]);

  useEffect(() => {
    setCardsLoader(true);
    const token = localStorage.getItem("token");
    const fetchCards = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/card/get-cards`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await res.json();
        setInitialCards(data.data);
        setCards(data.data);
      } catch (error) {
        console.error("Failed to fetch cards:", error);
      } finally {
        setTimeout(() => {
          setCardsLoader(false);
        }, 2000);
      }
    };
    if (token) {
      fetchCards();
    }
  }, []);

  const [orderModal, setOrderModal] = useState(false);

  const toggleOrderModal = () => {
    setOrderModal(!orderModal);
  };

  useEffect(() => {
    const fetchOccasion = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/event/get-active-event`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const res = await response.json();
        const status = res.code;
        if (status === 200) {
          setOccasion(res.data);
        }
      } catch (error) {
        console.error("Failed to fetch occasions:", error);
      }
    };
    fetchOccasion();
  }, []);

  const toggleFavorited = async (ID) => {
    const isCurrentlyFavorited = favorites?.includes(ID);
    let updatedFavorites;
    if (isCurrentlyFavorited) {
      updatedFavorites = favorites?.filter((favoriteId) => favoriteId !== ID);
    } else {
      updatedFavorites = [...favorites, ID];
    }
    setFavorites(updatedFavorites);

    const updatedCards = cards.map((card) => {
      if (card._id === ID) {
        return {
          ...card,
          isFavorited: !isCurrentlyFavorited,
        };
      }
      return card;
    });
    setCards(updatedCards);

    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/card/toggle-favourite-card/${ID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const data = await res.json();
      if (res.status !== 200) {
        throw new Error(data.message);
      }
    } catch (error) {
      console.error("Failed to toggle favorite status:", error);
      if (isCurrentlyFavorited) {
        setFavorites([...updatedFavorites, ID]);
      } else {
        setFavorites(
          updatedFavorites.filter((favoriteId) => favoriteId !== ID)
        );
      }

      const revertedCards = updatedCards.map((card) => {
        if (card._id === ID) {
          return {
            ...card,
            isFavorited: isCurrentlyFavorited,
          };
        }
        return card;
      });
      setCards(revertedCards);
    }
  };

  useEffect(() => {
    if (orderModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [orderModal]);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const currentCards = cards.slice(indexOfFirstCard, indexOfLastCard);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    // <section className="flex max-w-[1200px] mx-auto">
    <section className="flex mx-auto px-4 sm:px-2">
      <SidePanel />
      {cardsLoader ? (
        <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
          <div
            className="flex items-center justify-center"
            style={{ height: "calc(100vh - 10rem)" }}
          >
            <Spinner props="Loading" size={"80"} />
          </div>
        </div>
      ) : cards.length === 0 && !theme ? (
        <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
          <div className="flex lg:flex-row flex-col lg:gap-0 gap-5 items-start justify-between m-2">
            <div className="flex flex-col lg:w-[35%] w-full">
              <h1 className="text-4xl text-secondary lg:text-left text-center font-bold mb-5">
                Cards Generation
              </h1>
              <div className="flex items-center gap-x-4 w-full">
                <select
                  name="selectedOccasion"
                  value={selectedOccasion}
                  onChange={(e) => {
                    setSelectedOccasion(e.target.value);
                  }}
                  className="py-3 bg-white border-b-2 border-primary placeholder:text-gray-300 w-full"
                >
                  <option value="">Choose Occasion</option>
                  {occasion.map((occasion) => (
                    <option key={occasion._id} value={occasion.name}>
                      {occasion.name}
                    </option>
                  ))}
                </select>
                <select
                  name="forWhom"
                  value={forWhom}
                  onChange={(e) => setForWhom(e.target.value)}
                  required
                  className="py-3 bg-white border-b-2 border-primary placeholder:text-gray-300 w-full"
                >
                  <option value="">For Whom?</option>
                  <option value="Male">For Him</option>
                  <option value="female">For Her</option>
                </select>
              </div>
            </div>
            <div className="lg:w-[40%]">
              <div className="relative w-full ">
                <input
                  type="text"
                  name="theme"
                  value={theme}
                  onChange={(e) => setTheme(e.target.value)}
                  placeholder="Search for Themes"
                  className="bg-slate-50 shadow-md border-2 border-primary-color rounded-lg px-4 py-3 w-full focus:border-primary-light focus:ring-2 focus:ring-primary-light focus:outline-none"
                />
                <IoIosSearch
                  size={25}
                  className="absolute inset-y-0 right-1 top-3 text-primary"
                />
              </div>
            </div>
          </div>
          <div className="flex  items-center justify-center h-screen">
            <h1 className="text-3xl flex flex-col items-center text-gray-800 lg:text-left text-center font-bold mb-5 line-clamp-6">
              No cards available yet.
              <span> Try searching for another category.</span>
            </h1>
          </div>
        </div>
      ) : (
        <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
          {orderModal && (
            <GenerateCardPopup
              toggleOrderModal={toggleOrderModal}
              selectedCard={selectedCard}
              selectedCardID={selectedCardID}
              cards={cards}
            />
          )}
          <div className="flex lg:flex-row flex-col lg:gap-0 gap-5 items-start justify-between m-2">
            <div className="flex flex-col lg:w-[35%] w-full">
              <h1 className="text-4xl text-secondary lg:text-left text-center font-bold mb-5">
                Cards Generation
              </h1>
              <div className="flex items-center gap-x-4 w-full">
                <select
                  name="selectedOccasion"
                  value={selectedOccasion}
                  onChange={(e) => setSelectedOccasion(e.target.value)}
                  className="py-3 bg-white border-b-2 border-primary placeholder:text-gray-300 w-full"
                >
                  <option value="">Choose Occasion</option>
                  {occasion.map((occasion) => (
                    <option key={occasion._id} value={occasion.name}>
                      {occasion.name}
                    </option>
                  ))}
                </select>
                <select
                  name="forWhom"
                  value={forWhom}
                  onChange={(e) => setForWhom(e.target.value)}
                  required
                  className="py-3 bg-white border-b-2 border-primary placeholder:text-gray-300 w-full"
                >
                  <option value="">For Whom?</option>
                  <option value="Male">For Him</option>
                  <option value="female">For Her</option>
                </select>
              </div>
            </div>
            <div className="lg:w-[40%] w-full">
              <div className="relative w-full">
                <input
                  type="text"
                  name="theme"
                  value={theme}
                  onChange={(e) => setTheme(e.target.value)}
                  placeholder="Search for Themes"
                  className="bg-slate-50 shadow-md border-2 border-primary rounded-lg px-4 py-3 w-full"
                />
                <IoIosSearch
                  size={25}
                  className="absolute inset-y-0 right-1 top-3 text-primary"
                />
              </div>
              <button
                onClick={toggleOrderModal}
                className="flex items-center justify-center gap-x-2 bg-primary text-white text-xl py-2.5 my-3 w-full rounded-md hover:bg-primary-dark"
              >
                <span>
                  <MdAddToPhotos />
                </span>
                Generate Card
              </button>
            </div>
          </div>
          <div className="xl:grid grid-cols-5 flex flex-wrap items-center justify-center gap-3 my-10">
            {currentCards.map((card, index) => (
              <div className="relative w-fit" key={index}>
                <div>
                  <div>
                    <img
                      src={card.thumbnail}
                      alt="placeholder_img"
                      className="relative rounded-xl lg:w-96 w-52 inset-[-1] shadow-lg"
                    />
                    {favorites?.includes(card._id) ? (
                      <img
                        src={favourited_icon}
                        alt="Favorited Icon"
                        className="absolute inset-y-0 right-5 top-5 duration-300 ease-in cursor-pointer"
                        onClick={() => toggleFavorited(card._id)}
                      />
                    ) : (
                      <img
                        src={heart_icon}
                        alt="Heart Icon"
                        className="absolute inset-y-0 brightness-50 right-5 top-5 duration-300 ease-in cursor-pointer"
                        onClick={() => toggleFavorited(card._id)}
                      />
                    )}

                    <img className="mt-3 w-[80%] mb-2 m-auto" src={shadow} alt="" />
                  </div>
                </div>
                <button
                  onClick={() => {
                    setSelectedCard(card.thumbnail);
                    setSelectedCardID(card._id);
                    toggleOrderModal();
                  }}
                  className="border-2 border-primary text-primary text-lg py-1 mt-3 mb-4 w-full rounded-md hover:bg-primary-light"
                >
                  Select
                </button>
              </div>
            ))}
          </div>
          <Pagination
            cardsPerPage={cardsPerPage}
            totalCards={cards.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      )}
    </section>
  );
};

const Pagination = ({ cardsPerPage, totalCards, paginate, currentPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalCards / cardsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav className="flex items-center justify-center my-4">
      <ul className="flex space-x-2">
        {pageNumbers.map((number) => (
          <li key={number}>
            <button
              onClick={() => paginate(number)}
              className={`px-4 py-2 border-2 ${
                currentPage === number
                  ? "border-primary bg-primary text-white"
                  : "border-gray-300"
              } rounded-md hover:bg-primary hover:text-white`}
            >
              {number}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default CardGeneration;
